export enum SettingsEnum {
    OKTO = 'okto',
    CALLAS = 'callas',
    TRANSPORT = 'transport',
    MULTIPRESS = 'multipress',
    ORGANIZATION = 'organization',
    GIM = 'gim',
}
